var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-8",class:{
    'bg-grayBackgroundWeak': _vm.backgroundColorVariant === 'grey',
    'bg-white': _vm.backgroundColorVariant === 'white',
  }},[_c('div',{staticClass:"max-w-5xl gap-8 flex flex-wrap w-full justify-around items-center h-full m-auto"},_vm._l((_vm.subHeroItems),function(ref,index){
  var img = ref.img;
  var label = ref.label;
  var imageExplainerText = ref.imageExplainerText;
return _c('div',{key:index,staticClass:"flex flex-col items-center"},[(img)?_c('img',{attrs:{"src":img,"alt":imageExplainerText}}):_vm._e(),_vm._v(" "),(label)?_c('div',{staticClass:"font-bold text-center leading-none lg:leading-6 mt-3"},[_vm._v("\n        "+_vm._s(label)+"\n      ")]):_vm._e()])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }